// src/Chat/Sidebar.jsx
import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  BottomNavigation,
  BottomNavigationAction,
  Typography,
  List,
  ListItem,
  ListItemText,
  Avatar,
  ListItemAvatar,
  IconButton,
  InputBase,
  ListItemButton,
  Badge,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import ChatIcon from '@mui/icons-material/Chat';
import PeopleIcon from '@mui/icons-material/People';
import GroupIcon from '@mui/icons-material/Group';
import { useChatContext } from '../context/SignamRContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import PushPinIcon from '@mui/icons-material/PushPin';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import DoneIcon from '@mui/icons-material/Done';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useTranslation } from 'react-i18next';
import MuiDialog from '../Template/components/UI/MuiDialog/MuiDialog';
import OInput from '../Template/components/UI/FormControls/OInput';
import toast from 'react-hot-toast';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const WA_GREEN = '#ff8f28';
const WA_GREEN_HOVER = '#fd8412ff';
const WA_BLUE_TICK = '#53bdeb';
const DELETED_MESSAGE_TEXT = 'Ova poruka je obrisana';

const Sidebar = ({ isMobile, onSelectChat }) => {
  const timersRef = useRef({});
  const navigate = useNavigate();
  const {
    conversations,
    setConversations,
    setMessages,
    setConversationId,
    searchMessageId,
    setSearchMessageId,
  } = useChatContext();

  const [selectedTab, setSelectedTab] = useState('conversations');
  const [users, setUsers] = useState([]);
  const apiBaseUrl = process.env.REACT_APP_API_CHAT_PROD;
  const api = process.env.REACT_APP_PROD_API;
  const loggedInUserId = localStorage.getItem('idKorisnika');
  const canSeeGroupsTab = Number(localStorage.getItem('idFirme')) === 1;
  const [filterText, setFilterText] = useState('');
  const [showTabs, setShowTabs] = useState(false);
  const [activeTab, setActiveTab] = useState('conversations');
  const [messagesFilter, setMessagesFilter] = useState([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [idDelete, setIdDelete] = useState(0);
  const [openDialogForDelete, setOpenDialogForDelete] = useState(false);
  const [chatGroups, setChatGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [groupMembers, setGroupMembers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isCreatingGroup, setIsCreatingGroup] = useState(false);
  const [groupExistsErrorMessage, setGroupExistsErrorMessage] = useState('');
  const [openGroupMembersDialog, setOpenGroupMembersDialog] = useState(false);
  const [groupMembersDraft, setGroupMembersDraft] = useState([]);
  const [groupMembersSearch, setGroupMembersSearch] = useState('');
  const [openProjectsDialog, setOpenProjectsDialog] = useState(false);
  const [projectSearch, setProjectSearch] = useState('');
  const [openGroupsDialog, setOpenGroupsDialog] = useState(false);
  const [groupSearch, setGroupSearch] = useState('');
  const observerRef = useRef(null);
  const { t, i18n } = useTranslation();

  const [contextMenu, setContextMenu] = useState({
    mouseX: null,
    mouseY: null,
    open: false,
    item: null,
  });
  const showOptions = (event, item) => {
    event.preventDefault();
    setContextMenu({
      mouseX: event.clientX,
      mouseY: event.clientY,
      open: true,
      item,
    });
  };

  const handleCloseMenu = () => {
    setContextMenu({ ...contextMenu, open: false, item: null });
  };

  const clearFilter = async () => {
    setFilterText('');
    setShowTabs(false);
    setMessagesFilter([]);
    setActiveTab('conversations');
    setOffset(0);
    setHasMore(true);
    try {
      const response = await axios.post(
        `${apiBaseUrl}/Conversations/getConversation`,
        {
          id: loggedInUserId,
          name: '',
          offset: 0,
          next: 15,
        },
      );
      if (response.status === 200) {
        const rows = response.data || [];
        setConversations(rows);
        setHasMore(rows.length === 15);
      }
    } catch (error) {
      console.error('Greška prilikom dohvatanja konverzacija:', error);
    }
  };

  const handleDetails = () => {
    console.log('DETALJI za:', contextMenu.item);
    handleCloseMenu();
  };

  const handleDelete = () => {
    console.log('BRISANJE:', contextMenu.item.id);
    setIdDelete(contextMenu.item.id);
    setOpenDialogForDelete(true);
    // TODO: axios delete poziv ovde
    handleCloseMenu();
  };

  const handleDeleteChat = async () => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}/Conversations/chat_brisanje`,
        {
          id: idDelete,
        },
      );
      if (response.status === 200) {
        setIdDelete(0);
        setOpenDialogForDelete(false);
        clearFilter();
        toast.success('Uspešan ste obrisali konverzaciju');
      }
    } catch (error) {
      toast.error('Doslo je do greske prilikom brisanje konverzacije');
      console.error('Greška prilikom dohvatanja korisnika:', error);
    }
  };

  const resetCreateGroupForm = () => {
    setSelectedGroup(null);
    setGroupMembers([]);
    setSelectedProject(null);
    setGroupMembersDraft([]);
    setGroupMembersSearch('');
    setProjectSearch('');
    setGroupSearch('');
  };

  const openMembersPickerDialog = () => {
    setGroupMembersDraft(groupMembers);
    setGroupMembersSearch('');
    setOpenGroupMembersDialog(true);
  };

  const closeMembersPickerDialog = () => {
    setOpenGroupMembersDialog(false);
    setGroupMembersSearch('');
  };

  const toggleGroupMemberDraft = (member) => {
    const exists = groupMembersDraft.some(
      (item) => Number(item.id) === Number(member.id),
    );
    if (exists) {
      setGroupMembersDraft((prev) =>
        prev.filter((item) => Number(item.id) !== Number(member.id)),
      );
    } else {
      setGroupMembersDraft((prev) => [...prev, member]);
    }
  };

  const handleConfirmMembersPicker = () => {
    setGroupMembers(groupMembersDraft);
    closeMembersPickerDialog();
  };

  const openProjectsPickerDialog = () => {
    setProjectSearch('');
    setOpenProjectsDialog(true);
  };

  const closeProjectsPickerDialog = () => {
    setOpenProjectsDialog(false);
    setProjectSearch('');
  };

  const openGroupsPickerDialog = () => {
    setGroupSearch('');
    setOpenGroupsDialog(true);
  };

  const closeGroupsPickerDialog = () => {
    setOpenGroupsDialog(false);
    setGroupSearch('');
  };

  const handleCreateGroup = async () => {
    if (!selectedGroup?.vrednost) {
      toast.error('Izaberite naziv grupe.');
      return;
    }
    if (groupMembers.length < 2) {
      toast.error('Morate izabrati najmanje dva člana grupe.');
      return;
    }
    if (!selectedProject?.id) {
      toast.error('Izaberite projekat.');
      return;
    }

    try {
      setIsCreatingGroup(true);

      const groupCheckResponse = await axios.post(
        `${apiBaseUrl}/Konverzacije/provera_postojanja_grupe`,
        {
          name: selectedGroup.vrednost,
          idMasine: Number(selectedProject.id),
        },
      );
      const groupCheckData = groupCheckResponse.data;

      if (Number(groupCheckData?.rezultat) === -2) {
        setGroupExistsErrorMessage(
          groupCheckData.opis ||
            'Grupa sa izabranim nazivom i projektom već postoji.',
        );
        return;
      }

      const membersPayload = groupMembers.map((memberId) => {
        const selectedUser = users.find(
          (u) => Number(u.id || u.Id) === Number(memberId.id || memberId.Id),
        );
        return {
          Value: Number(memberId.id || memberId.Id),
          Label: selectedUser?.name || selectedUser?.Name || '',
        };
      });

      const payload = {
        Id: Number(loggedInUserId) || null,
        Name: selectedGroup.vrednost,
        IsGroup: true,
        Members: membersPayload,
        Logo: '',
        IdMasineInterno: Number(selectedProject.id),
      };

      const response = await axios.post(
        `${apiBaseUrl}/Konverzacije/create_conversations`,
        payload,
      );

      if (response.status === 200) {
        toast.success('Grupa je uspešno kreirana.');
        resetCreateGroupForm();
      }
    } catch (error) {
      toast.error('Došlo je do greške prilikom kreiranja grupe.');
      console.error('Greška prilikom kreiranja grupe:', error);
    } finally {
      setIsCreatingGroup(false);
    }
  };

  async function fetchConversations(append = false, customOffset = null) {
    try {
      const requestOffset = customOffset ?? offset;
      const response = await axios.post(
        `${apiBaseUrl}/Conversations/getConversation`,
        {
          id: loggedInUserId,
          name: filterText.trim(),
          offset: requestOffset,
          next: 15,
        },
      );

      if (response.status === 200) {
        const newData = response.data || [];
        if (append) {
          // Dodaj na kraj postojećih
          setConversations((prev) => [...prev, ...newData]);
        } else {
          // Inicijalno učitavanje
          setConversations(newData);
        }

        // Ako je stiglo manje od 15 — nema više
        setHasMore(newData.length === 15);
      }
    } catch (error) {
      console.error('Greška prilikom dohvatanja konverzacija:', error);
    }
  }

  useEffect(() => {
    if (selectedTab === 'conversations') {
      setOffset(0);
      setHasMore(true);
      fetchConversations(false, 0);
    }
  }, [selectedTab]);

  useEffect(() => {
    const fetchConversations = async () => {
      try {
        const response = await axios.post(
          `${apiBaseUrl}/Conversations/getConversation`,
          {
            id: loggedInUserId,
            offset: 0,
            next: 15,
          },
        );
        if (response.status === 200) {
          setConversations(response.data || []);
        }
      } catch (error) {
        console.error('Greška prilikom dohvatanja konverzacija:', error);
      }
    };
    if (selectedTab === 'conversations') {
      fetchConversations();
    }
  }, [selectedTab]);

  useEffect(() => {
    if (selectedTab === 'groups' && !canSeeGroupsTab) {
      setSelectedTab('conversations');
      return;
    }
    const fetchUsers = async () => {
      try {
        const response = await axios.post(
          `${apiBaseUrl}/Conversations/getUsers`,
          {
            id: loggedInUserId,
          },
        );
        if (response.status === 200) {
          setUsers(response.data);
        }
      } catch (error) {
        console.error('Greška prilikom dohvatanja korisnika:', error);
      }
    };
    if (selectedTab === 'users' || selectedTab === 'groups') fetchUsers();
  }, [selectedTab, canSeeGroupsTab]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(`${api}Combo/vrati_projekte_combo`);
        if (response.status === 200) {
          setProjects(Array.isArray(response.data) ? response.data : []);
        }
      } catch (error) {
        console.error('Greška prilikom dohvatanja projekata:', error);
      }
    };
    if (selectedTab === 'groups' && canSeeGroupsTab && !projects.length) {
      fetchProjects();
    }
  }, [selectedTab, projects.length, canSeeGroupsTab]);

  useEffect(() => {
    const fetchChatGroups = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/Combo/GrupeZaChat_pregled`,
        );
        if (response.status === 200) {
          setChatGroups(Array.isArray(response.data) ? response.data : []);
        }
      } catch (error) {
        console.error('Greška prilikom dohvatanja grupa za chat:', error);
      }
    };
    if (selectedTab === 'groups' && canSeeGroupsTab && !chatGroups.length) {
      fetchChatGroups();
    }
  }, [selectedTab, chatGroups.length, canSeeGroupsTab]);

  const getDisplayName = (item) => {
    if (item.name || item.Name) return item.name || item.Name;
    const otherUser = item.users?.find((u) => u.user?.id !== +loggedInUserId);
    return otherUser?.user?.name || 'Nepoznat';
  };

  const getInitials = (item) => {
    const name = getDisplayName(item);
    return name
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase();
  };

  const handleSelectConversation = async (item) => {
    if (selectedTab === 'users') {
      // Novi korisnik — kreiraj ili pronađi konverzaciju
      try {
        const selectedUserId = item.id || item.Id;
        const selectedUserName = item.name || item.Name;
        const selectedConversationId =
          item.conversationId || item.ConversationId;
        const selected = [{ value: selectedUserId, label: selectedUserName }];
        const userId = parseInt(localStorage.getItem('idKorisnika') || '0', 10);

        if (!selectedConversationId) {
          // Kreiraj novu konverzaciju
          const res = await axios.post(
            `${apiBaseUrl}/Konverzacije/create_conversations`,
            {
              id: userId,
              members: selected,
              isGroup: false,
              name: '',
            },
          );

          if (res.status === 200) {
            const newConv = res.data;
            setConversationId(newConv.id);

            // Osveži listu konverzacija
            const refreshed = await axios.post(
              `${apiBaseUrl}/Conversations/getConversation`,
              { id: userId, offset: 0, next: 15 },
            );
            if (refreshed.status === 200) {
              setConversations(refreshed.data);
            }

            // Otvori konverzaciju
            const fullConv = await axios.post(
              `${apiBaseUrl}/Conversations/getConversationById`,
              {
                conversationId: newConv.id,
                userId: userId,
                offset: 0,
                next: 15,
              },
            );

            if (fullConv.status === 200) {
              setMessages(fullConv.data || []);
              onSelectChat(fullConv.data);
            }
          }
        } else {
          // Postoji conversationId – otvori
          const res = await axios.post(
            `${apiBaseUrl}/Conversations/getConversationById`,
            {
              conversationId: selectedConversationId,
              userId: userId,
              offset: 0,
              next: 15,
            },
          );

          if (res.status === 200) {
            setConversationId(res.data.id);
            setMessages(res.data);
            onSelectChat(res.data);
          }
        }
      } catch (error) {
        console.error(
          'Greška prilikom otvaranja/kreiranja konverzacije:',
          error,
        );
      }
    } else {
      // Postojeća konverzacija (tab "conversations")
      // TESTIRANJE važi samo u sesiji korisnika koji ju je dodao — ne nasleđuje se
      const potOznaka = item.poslednjaOznaka || 'null';
      localStorage.setItem(
        'oznaka',
        String(potOznaka).toUpperCase() === 'TESTIRANJE' ? 'null' : potOznaka,
      );
      setConversationId(item.id);
      try {
        const response = await axios.post(
          `${apiBaseUrl}/Conversations/getConversationById`,
          {
            conversationId: item.id,
            userId: loggedInUserId,
            offset: 0,
            next: item.rb || 15,
          },
        );

        if (response.status === 200) {
          setMessages(response.data);
          onSelectChat({ ...item, ...(response.data || {}) });
          if (item.rb) {
            setSearchMessageId(item.messageId);
          }
          // Pozovi "seen" samo ako ima poruka
          if (
            Array.isArray(response.data?.messages) &&
            response.data.messages.length > 0
          ) {
            try {
              await axios.post(`${apiBaseUrl}/Messages/seen`, {
                conversationId: item.id,
                userId: loggedInUserId,
              });
            } catch (err) {
              console.warn('Greška pri označavanju kao viđeno:', err);
            }
          }
        }
      } catch (error) {
        console.error('Greška prilikom dohvatanja poruka:', error);
      }
    }
  };
  const formatTime = (d) => {
    if (!d) return '';
    const date =
      typeof d === 'string' || typeof d === 'number' ? new Date(d) : d;
    const now = new Date();
    const isToday = date.toDateString() === now.toDateString();
    const isThisYear = date.getFullYear() === now.getFullYear();
    if (isToday) {
      return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
      });
    }
    if (isThisYear) {
      return date.toLocaleDateString([], { month: 'short', day: 'numeric' });
    }
    return date.toLocaleDateString();
  };

  const getTickIcon = (users, lastMsg, seenIds) => {
    const loggedId = +loggedInUserId;

    const otherUserIds = (users ?? [])
      .map((u) => u.userId)
      .filter((id) => id !== lastMsg?.senderId && id !== loggedId);

    // iz seenIds izbacujemo ulogovanog i sendera
    const seenOtherIds = seenIds.filter(
      (id) => id !== lastMsg?.senderId && id !== loggedId,
    );

    // isSame: imaju isti broj i iste članove (redosled nebitan)
    const isSame =
      otherUserIds.length === seenOtherIds.length &&
      otherUserIds.every((id) => seenOtherIds.includes(id));

    if (isSame) {
      console.log('SAME TRUE');
      console.log(otherUserIds);
      console.log(seenIds);
    }

    // if (!lastMsg || lastMsg.senderId !== +loggedInUserId) return null;
    // const othersSeen = Array.isArray(seenIds)
    //   ? seenIds.filter((id) => +id !== +loggedInUserId).length
    //   : 0;

    // WhatsApp-like:
    // - Done (single) = poslato
    // - DoneAll sivo = isporučeno
    // - DoneAll plavo = pročitano (bar 1 primalac)
    // Pošto nemamo poseban "delivered", koristimo seenIds kao signal za "pročitano".

    if (isSame) {
      return (
        <DoneAllIcon sx={{ fontSize: 18, color: WA_BLUE_TICK, mr: 0.5 }} />
      );
    }
    return (
      <DoneAllIcon sx={{ fontSize: 18, color: 'text.secondary', mr: 0.5 }} />
    );
  };

  const fetchMessages = async () => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}/Messages/vracanje_poruka_iz_konverzacija`,
        {
          idKorProm: loggedInUserId,
          uslovPretrage: filterText.trim(),
        },
      );
      if (response.status === 200) {
        setMessagesFilter(response.data);
      }
    } catch (error) {
      console.error('Greška prilikom dohvatanja poruka:', error);
    }
  };
  const handleSearch = async (type) => {
    const trimmedFilter = filterText.trim();
    if (trimmedFilter.length < 3) {
      toast.error(t('searchMinChars'));
      return;
    }

    setShowTabs(true);

    if (type === 'conversations') {
      setOffset(0);
      setHasMore(true);
      await fetchConversations(false, 0);
      return;
    }

    if (type === 'messages') {
      await fetchMessages();
      return;
    }

    // ako type nije definisan ili nije odgovarajući string
    if (activeTab === 'conversations') {
      setOffset(0);
      setHasMore(true);
      await fetchConversations(false, 0);
    } else if (activeTab === 'messages') {
      await fetchMessages();
    }
  };

  useEffect(() => {
    if (selectedTab !== 'conversations' || !hasMore || showTabs)
      return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          setOffset((prev) => prev + 15); // pomeri offset
        }
      },
      { threshold: 1.0 },
    );

    if (observerRef.current) observer.observe(observerRef.current);

    return () => observer.disconnect();
  }, [selectedTab, hasMore, showTabs]);

  useEffect(() => {
    if (offset === 0) return; // preskoči inicijalno
    fetchConversations(true);
  }, [offset]);

  const mappedUsersForGroupForm = (users || [])
    .filter((u) => Number(u.id || u.Id) !== Number(loggedInUserId))
    .map((u) => ({
      id: Number(u.id || u.Id),
      vrednost: u.name || u.Name || '',
    }));

  const filteredMappedUsers = mappedUsersForGroupForm.filter((u) =>
    u.vrednost.toLowerCase().includes(groupMembersSearch.toLowerCase()),
  );
  const mappedProjectsForGroupForm = (projects || []).map((project) => ({
    ...project,
    id: Number(project.id || project.value),
    vrednost: project.vrednost || project.label || project.name || '',
  }));
  const filteredMappedProjects = mappedProjectsForGroupForm.filter((project) =>
    project.vrednost.toLowerCase().includes(projectSearch.toLowerCase()),
  );
  const mappedChatGroupsForGroupForm = (chatGroups || []).map((group) => ({
    ...group,
    id: Number(group.id || group.value),
    vrednost: group.vrednost || group.label || group.name || '',
  }));
  const filteredMappedChatGroups = mappedChatGroupsForGroupForm.filter(
    (group) => group.vrednost.toLowerCase().includes(groupSearch.toLowerCase()),
  );

  const renderList = () => {
    let data = [];
    if (selectedTab === 'users') {
      data = users || [];
    } else if (!showTabs || activeTab === 'conversations') {
      data = conversations || [];
    } else if (activeTab === 'messages') {
      data = messagesFilter || [];
    }

    return (
      <List sx={{ py: 0 }}>
        {selectedTab === 'conversations' && (
          <Box
            sx={{
              px: 2,
              py: 1.25,
              borderBottom: '1px solid #ddd',
              display: 'flex',
              gap: 1,
              alignItems: 'center',
              bgcolor: alpha('#000', 0.02),
            }}
          >
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 1.5,
                py: 0.75,
                borderRadius: 2,
                bgcolor: alpha('#000', 0.04),
                border: '1px solid',
                borderColor: alpha('#000', 0.08),
              }}
            >
              <SearchIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
              <InputBase
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault(); // sprečava novi red
                    handleSearch(); // tvoja funkcija za pretragu
                  }
                }}
                placeholder={t('search')}
                sx={{ fontSize: 14, flex: 1 }}
              />
            </Box>
            <IconButton
              onClick={handleSearch}
              size="small"
              sx={{
                border: '1px solid',
                borderColor: alpha('#000', 0.12),
                borderRadius: 2,
              }}
              title="Osveži"
            >
              <SearchIcon fontSize="small" />
            </IconButton>
            <IconButton
              onClick={() => {
                clearFilter();
              }}
              size="small"
              sx={{
                border: '1px solid',
                borderColor: alpha('#000', 0.12),
                borderRadius: 2,
              }}
              title="Poništi filter"
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          </Box>
        )}

        {showTabs && (
          <Tabs
            value={activeTab}
            onChange={(e, newValue) => setActiveTab(newValue)}
            variant="fullWidth"
          >
            <Tab
              value="conversations"
              label={t('group')}
              onClick={() => handleSearch('conversations')}
            />
            <Tab
              value="messages"
              label={t('message')}
              onClick={() => handleSearch('messages')}
            />
          </Tabs>
        )}
        {data.map((item) => {
          if (activeTab === 'messages') {
            return (
              <ListItemButton
                key={item.id}
                onClick={() =>
                  handleSelectConversation({
                    id: item.conversationId,
                    name: item.conversationName,
                    rb: item.rb,
                    messageId: item.id,
                    logo: item.logo,
                  })
                }
                sx={{
                  gap: 1.25,
                  alignItems: 'flex-start',
                  py: 1,
                  px: 1.5,
                  borderBottom: '1px solid #eee',
                  '&:hover': {
                    bgcolor: alpha(WA_GREEN, 0.08),
                  },
                }}
              >
                <ListItemAvatar sx={{ minWidth: 48 }}>
                  {item.logo ? (
                    <Avatar src={item.logo} alt={getDisplayName(item)} />
                  ) : (
                    <Avatar>{getInitials(item)}</Avatar>
                  )}
                </ListItemAvatar>

                <Box sx={{ flex: 1, minWidth: 0 }}>
                  {/* Naziv konverzacije */}
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 0.25,
                    }}
                  >
                    <Typography
                      noWrap
                      sx={{ fontWeight: 600, fontSize: 15 }}
                      title={item.conversationName}
                    >
                      {item.conversationName}
                    </Typography>

                    <Typography
                      sx={{
                        fontSize: 12,
                        color: 'text.secondary',
                        flexShrink: 0,
                      }}
                    >
                      {formatTime(item.createdAt)}
                    </Typography>
                  </Box>

                  {/* Ime pošiljaoca + poruka */}
                  <Typography
                    noWrap
                    sx={{
                      fontSize: 13.5,
                      color: 'text.secondary',
                      lineHeight: 1.4,
                    }}
                    title={item.body}
                  >
                    <strong>{item.name}:</strong> {item.body}
                  </Typography>
                </Box>
              </ListItemButton>
            );
          }
          const lastMsg = item.messages?.[item.messages.length - 1];
          const seenIds = lastMsg?.seenIds ? JSON.parse(lastMsg.seenIds) : [];
          const isUnread =
            lastMsg &&
            lastMsg.senderId !== +loggedInUserId &&
            (!lastMsg.seenIds ||
              !JSON.parse(lastMsg.seenIds).includes(+loggedInUserId));

          const unreadCount = item.messages
            ? item.messages.filter(
                (msg) =>
                  msg.senderId !== +loggedInUserId &&
                  (!msg.seenIds ||
                    !JSON.parse(msg.seenIds).includes(+loggedInUserId)),
              ).length
            : 0;

          const unreadDisplay =
            unreadCount > 9 ? '10+' : unreadCount > 0 ? unreadCount : null;

          const handlePointerDown = (e) => {
            timersRef.current[item.id] = setTimeout(() => {
              showOptions(e, item);
            }, 600);
          };
          const clearTimer = () => {
            const t = timersRef.current[item.id];
            if (t) {
              clearTimeout(t);
              delete timersRef.current[item.id];
            }
          };

          const previewText = lastMsg?.body?.trim()
            ? lastMsg.body
            : item.preview || '';
          const isDeletedPreview = previewText === DELETED_MESSAGE_TEXT;

          return (
            <ListItemButton
              key={item.id || item.Id}
              onClick={() => handleSelectConversation(item)}
              onPointerDown={handlePointerDown}
              onPointerUp={clearTimer}
              onPointerLeave={clearTimer}
              onContextMenu={(e) => showOptions(e, item)}
              sx={{
                gap: 1.25,
                alignItems: 'center',
                py: 1.25,
                px: 1.5,
                borderBottom: '1px solid #eee',
                height: 72,
                '&:hover': {
                  bgcolor: alpha(WA_GREEN, 0.08),
                },
              }}
            >
              <ListItemAvatar sx={{ minWidth: 56 }}>
                <Box sx={{ position: 'relative' }}>
                  {item.logo ? (
                    <Avatar src={item.logo} alt={getDisplayName(item)} />
                  ) : (
                    <Avatar>{getInitials(item)}</Avatar>
                  )}
                  {item.isOnline && (
                    <Box
                      sx={{
                        position: 'absolute',
                        right: -1,
                        bottom: -1,
                        width: 12,
                        height: 12,
                        bgcolor: '#4caf50',
                        borderRadius: '50%',
                        border: '2px solid white',
                      }}
                    />
                  )}
                </Box>
              </ListItemAvatar>

              <Box sx={{ flex: 1, minWidth: 0 }}>
                {/* Prva linija: Ime + ikone (pin/mute) + vreme */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    justifyContent: 'space-between',
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 0.5,
                      minWidth: 0,
                    }}
                  >
                    <Typography
                      noWrap
                      sx={{
                        fontWeight: isUnread ? 700 : 600,
                        fontSize: 15,
                      }}
                    >
                      {getDisplayName(item)}
                    </Typography>
                    {item.pinned && (
                      <PushPinIcon
                        sx={{ fontSize: 16, color: 'text.secondary' }}
                      />
                    )}
                    {item.isMuted && (
                      <VolumeOffIcon
                        sx={{ fontSize: 16, color: 'text.secondary' }}
                      />
                    )}
                  </Box>

                  <Typography
                    sx={{
                      fontSize: 12,
                      color: isUnread ? WA_GREEN : 'text.secondary',
                      fontWeight: isUnread ? 700 : 400,
                      ml: 1,
                      flexShrink: 0,
                    }}
                  >
                    {formatTime(lastMsg?.createdAt || lastMsg?.timestamp)}
                  </Typography>
                </Box>

                {/* Druga linija: (ticks) poslednja poruka */}
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.25,
                    minWidth: 0,
                  }}
                >
                  {lastMsg?.senderId === +loggedInUserId &&
                    getTickIcon(item.users, lastMsg, seenIds)}
                  <Typography
                    noWrap
                    sx={{
                      fontSize: 13.5,
                      color: isDeletedPreview
                        ? 'rgba(0,0,0,0.55)'
                        : isUnread
                        ? 'text.primary'
                        : 'text.secondary',
                      fontWeight: isDeletedPreview ? 500 : isUnread ? 600 : 400,
                      fontStyle: isDeletedPreview ? 'italic' : 'normal',
                      lineHeight: 1.4,
                      minWidth: 0,
                    }}
                    title={previewText}
                  >
                    {lastMsg
                      ? `${
                          lastMsg.senderId === +loggedInUserId
                            ? t('you')
                            : lastMsg.sender?.name || 'Nepoznato'
                        }: ${
                          previewText?.length > 60
                            ? `${previewText.slice(0, 60)}…`
                            : previewText || ''
                        }`
                      : item.preview || ''}
                  </Typography>
                </Box>
              </Box>

              {/* Desna kolona: unread badge */}
              {unreadDisplay ? (
                <Badge
                  badgeContent={unreadDisplay}
                  color="success"
                  sx={{
                    '& .MuiBadge-badge': {
                      bgcolor: WA_GREEN,
                      color: '#fff',
                      fontSize: 12,
                      height: 22,
                      minWidth: 22,
                      fontWeight: 700,
                      marginRight: '10px',
                      marginTop: '10px',
                    },
                  }}
                />
              ) : null}
            </ListItemButton>
          );
        })}
        {selectedTab === 'conversations' && hasMore && (
          <div
            ref={observerRef}
            style={{
              height: '30px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#999',
              fontSize: 12,
            }}
          >
            Učitavam još...
          </div>
        )}
      </List>
    );
  };

  const renderCreateGroupForm = () => {
    const selectedMembersPreview = groupMembers
      .map((member) => member.vrednost)
      .slice(0, 2)
      .join(', ');
    const selectedMembersSummary =
      groupMembers.length === 0
        ? 'Izaberite članove'
        : groupMembers.length <= 2
        ? selectedMembersPreview
        : `${selectedMembersPreview}, ...`;

    return (
      <Box sx={{ p: 2.5, display: 'flex', flexDirection: 'column', gap: 2.25 }}>
        <Box>
          <Box
            onClick={openGroupsPickerDialog}
            sx={{
              minHeight: 20,
              border: '1px solid',
              borderColor: alpha('#000', 0.23),
              borderRadius: 1,
              px: 1.5,
              py: 1.25,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              cursor: 'pointer',
              '&:hover': {
                borderColor: alpha('#000', 0.45),
              },
            }}
          >
            <Typography
              noWrap
              sx={{
                color: selectedGroup?.vrednost
                  ? 'text.primary'
                  : 'text.secondary',
                pr: 1,
              }}
              title={selectedGroup?.vrednost || ''}
            >
              {selectedGroup?.vrednost || 'Izaberite naziv grupe'}
            </Typography>
            <ExpandMoreIcon sx={{ color: 'text.secondary' }} />
          </Box>
        </Box>

        <Box>
          <Box
            onClick={openMembersPickerDialog}
            sx={{
              minHeight: 20,
              border: '1px solid',
              borderColor: alpha('#000', 0.23),
              borderRadius: 1,
              px: 1.5,
              py: 1.25,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              cursor: 'pointer',
              '&:hover': {
                borderColor: alpha('#000', 0.45),
              },
            }}
          >
            <Typography
              noWrap
              sx={{
                color:
                  groupMembers.length > 0 ? 'text.primary' : 'text.secondary',
                pr: 1,
              }}
              title={groupMembers.map((member) => member.vrednost).join(', ')}
            >
              {selectedMembersSummary}
            </Typography>
            <ExpandMoreIcon sx={{ color: 'text.secondary' }} />
          </Box>
        </Box>

        <Box>
          <Box
            onClick={openProjectsPickerDialog}
            sx={{
              minHeight: 20,
              border: '1px solid',
              borderColor: alpha('#000', 0.23),
              borderRadius: 1,
              px: 1.5,
              py: 1.25,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              cursor: 'pointer',
              '&:hover': {
                borderColor: alpha('#000', 0.45),
              },
            }}
          >
            <Typography
              noWrap
              sx={{
                color: selectedProject?.vrednost
                  ? 'text.primary'
                  : 'text.secondary',
                pr: 1,
              }}
              title={selectedProject?.vrednost || ''}
            >
              {selectedProject?.vrednost || 'Izaberite projekat'}
            </Typography>
            <ExpandMoreIcon sx={{ color: 'text.secondary' }} />
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: 1.25,
            pt: 0.5,
          }}
        >
          <Button
            onClick={resetCreateGroupForm}
            variant="outlined"
            sx={{
              color: WA_GREEN,
              borderColor: WA_GREEN,
              bgcolor: '#fff',
              '&:hover': {
                bgcolor: alpha(WA_GREEN, 0.08),
                borderColor: WA_GREEN,
              },
            }}
          >
            Otkaži
          </Button>
          <Button
            onClick={handleCreateGroup}
            variant="contained"
            disabled={isCreatingGroup}
            sx={{
              px: 2.5,
              py: 1,
              bgcolor: WA_GREEN,
              '&:hover': { bgcolor: WA_GREEN_HOVER },
            }}
          >
            Sačuvaj
          </Button>
        </Box>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        width: isMobile ? '100%' : 320,
        height: '100%',
        borderRight: '1px solid #ddd',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#fff',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          px: 2,
          py: 1.25,
          borderBottom: '1px solid #ddd',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          bgcolor: '#f0f2f5',
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, fontSize: 18 }}>
          Chats
        </Typography>
        {/* <IconButton onClick={() => navigate('/')} size="small" title="Početna">
          <HomeIcon sx={{ color: WA_GREEN }} />
        </IconButton> */}
      </Box>

      {/* Tabs (ako želiš WA-like, može i da ostane ovako) */}
      <Box
        sx={{
          px: 1.5,
          py: 0.5,
          // borderBottom: '1px solid #ddd',
          bgcolor: '#f7f8fa',
        }}
      >
        <BottomNavigation
          showLabels
          value={selectedTab}
          onChange={(event, newValue) => setSelectedTab(newValue)}
          sx={{
            '& .Mui-selected': { color: `${WA_GREEN} !important` },
            '& .MuiBottomNavigationAction-label.Mui-selected': {
              fontWeight: 700,
            },
          }}
        >
          <BottomNavigationAction
            label="Konverzacije"
            value="conversations"
            icon={<ChatIcon />}
          />
          {/* <BottomNavigationAction
            label="Korisnici"
            value="users"
            icon={<PeopleIcon />}
          /> */}
          {canSeeGroupsTab && (
            <BottomNavigationAction
              label="Grupe"
              value="groups"
              icon={<GroupIcon />}
            />
          )}
        </BottomNavigation>
      </Box>

      {/* Lista */}
      <Box
        sx={{
          flex: 1,
          overflow: 'auto',
          maxBlockSize: 'fit-content',
          minHeight: '56vh',
        }}
      >
        {selectedTab === 'groups' ? renderCreateGroupForm() : renderList()}
      </Box>

      {/* Context meni (long-press / right-click) */}
      {localStorage.getItem('sa') === 'true' && (
        <Menu
          open={contextMenu.open}
          onClose={handleCloseMenu}
          anchorReference="anchorPosition"
          anchorPosition={
            contextMenu.mouseY !== null && contextMenu.mouseX !== null
              ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
              : undefined
          }
        >
          {/* <MenuItem onClick={handleDetails}>Detalji</MenuItem> */}
          <MenuItem onClick={handleDelete}>
            <DeleteOutlineIcon
              sx={{ fontSize: 18, mr: 1, color: 'error.main' }}
            />
            Obriši
          </MenuItem>
        </Menu>
      )}
      <MuiDialog
        maxWidth="sm"
        open={openDialogForDelete}
        text="Da li ste sigurni da želite da obrišete konverzaciju?"
        handleClose={() => setOpenDialogForDelete(false)}
        handleConfirm={handleDeleteChat}
        deniedText="Zatvori"
      />
      <Dialog
        open={Boolean(groupExistsErrorMessage)}
        onClose={() => setGroupExistsErrorMessage('')}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Upozorenje</DialogTitle>
        <DialogContent>
          <Typography sx={{ whiteSpace: 'pre-line' }}>
            {groupExistsErrorMessage}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            variant="contained"
            onClick={() => setGroupExistsErrorMessage('')}
            sx={{
              bgcolor: WA_GREEN,
              '&:hover': { bgcolor: WA_GREEN_HOVER },
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openGroupMembersDialog}
        onClose={closeMembersPickerDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Izbor članova grupe</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 1 }}>
            <OInput
              label="Pretraga članova"
              name="groupMembersSearch"
              value={groupMembersSearch}
              handleChange={(event) =>
                setGroupMembersSearch(event.target.value)
              }
              style={{ width: '100%' }}
            />
          </Box>
          <List sx={{ maxHeight: 320, overflowY: 'auto', py: 1 }}>
            {filteredMappedUsers.map((member) => (
              <ListItemButton
                key={member.id}
                onClick={() => toggleGroupMemberDraft(member)}
                sx={{ borderRadius: 1 }}
              >
                <Checkbox
                  checked={groupMembersDraft.some(
                    (item) => Number(item.id) === Number(member.id),
                  )}
                />
                <ListItemText primary={member.vrednost} />
              </ListItemButton>
            ))}
            {!filteredMappedUsers.length && (
              <Typography sx={{ p: 1, color: 'text.secondary' }}>
                Nema rezultata.
              </Typography>
            )}
          </List>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={closeMembersPickerDialog}
            variant="outlined"
            sx={{
              color: WA_GREEN,
              borderColor: WA_GREEN,
              bgcolor: '#fff',
              '&:hover': {
                bgcolor: alpha(WA_GREEN, 0.08),
                borderColor: WA_GREEN,
              },
            }}
          >
            Otkaži
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirmMembersPicker}
            sx={{
              bgcolor: WA_GREEN,
              '&:hover': { bgcolor: WA_GREEN_HOVER },
            }}
          >
            Potvrdi
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openProjectsDialog}
        onClose={closeProjectsPickerDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Izbor projekta</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 1 }}>
            <OInput
              label="Pretraga projekta"
              name="projectSearch"
              value={projectSearch}
              handleChange={(event) => setProjectSearch(event.target.value)}
              style={{ width: '100%' }}
            />
          </Box>
          <List sx={{ maxHeight: 320, overflowY: 'auto', py: 1 }}>
            {filteredMappedProjects.map((project) => (
              <ListItemButton
                key={project.id}
                onClick={() => {
                  setSelectedProject(project);
                  closeProjectsPickerDialog();
                }}
                sx={{ borderRadius: 1 }}
              >
                <ListItemText primary={project.vrednost} />
              </ListItemButton>
            ))}
            {!filteredMappedProjects.length && (
              <Typography sx={{ p: 1, color: 'text.secondary' }}>
                Nema rezultata.
              </Typography>
            )}
          </List>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={closeProjectsPickerDialog}
            variant="outlined"
            sx={{
              color: WA_GREEN,
              borderColor: WA_GREEN,
              bgcolor: '#fff',
              '&:hover': {
                bgcolor: alpha(WA_GREEN, 0.08),
                borderColor: WA_GREEN,
              },
            }}
          >
            Otkaži
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openGroupsDialog}
        onClose={closeGroupsPickerDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Izbor naziva grupe</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 1 }}>
            <OInput
              label="Pretraga naziva grupe"
              name="groupSearch"
              value={groupSearch}
              handleChange={(event) => setGroupSearch(event.target.value)}
              style={{ width: '100%' }}
            />
          </Box>
          <List sx={{ maxHeight: 320, overflowY: 'auto', py: 1 }}>
            {filteredMappedChatGroups.map((group) => (
              <ListItemButton
                key={group.id}
                onClick={() => {
                  setSelectedGroup(group);
                  closeGroupsPickerDialog();
                }}
                sx={{ borderRadius: 1 }}
              >
                <ListItemText primary={group.vrednost} />
              </ListItemButton>
            ))}
            {!filteredMappedChatGroups.length && (
              <Typography sx={{ p: 1, color: 'text.secondary' }}>
                Nema rezultata.
              </Typography>
            )}
          </List>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={closeGroupsPickerDialog}
            variant="outlined"
            sx={{
              color: WA_GREEN,
              borderColor: WA_GREEN,
              bgcolor: '#fff',
              '&:hover': {
                bgcolor: alpha(WA_GREEN, 0.08),
                borderColor: WA_GREEN,
              },
            }}
          >
            Otkaži
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Sidebar;
